module.exports = __webpack_public_path__ + "img/guaikuang-map.0f40a630.jpg";